<template>
    <footer id="footer" class="footer" :class="{'white' : theme == 'white'}">
        <div class="footer-outline">
            <div>© 2024 CMYK+WHITE, Inc. All Rights Reserved.</div>
        </div>
    </footer>
</template>



<script>
import { EventBus }     	from '../../event-bus.js';

export default {
    name: 'app-header',
    data() {
        return {
            theme       : ''
        }
    },
    created() {
        EventBus.$on('theme', (v) => {
            (v == 'white') ? this.theme = 'white' : this.theme = ''
        })
    },
}
</script>


<style lang="scss" scoped>
    @import '../../assets/scss/pages/footer.scss';
</style>


// WEBPACK FOOTER //
// src/pages/common/footer.vue